// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"74b2a0d9","453":"33f68927","455":"8abd002b","977":"32169c0b"}[chunkId] + ".chunk.js";
};